import { SectionType } from '../enums/section-type.enum';

export interface TestRouteSectionInterface {
  id: string;
  type: string;
  headline: string;
  anchor: string;
  previewSmall: string;
  previewLarge: string;
  routes: {
    day: number;
  }[];
}

export class TestRouteSectionModel {
  public id: string;
  public type = SectionType.TEST_ROUTE;
  public headline: string;
  public anchor: string;
  public customHeadline = true;
  public previewSmall: string;
  public previewLarge: string;

  public routes: { day: number; routeCount: number }[] = [];
  constructor(data: TestRouteSectionInterface) {
    this.id = data.id;
    this.headline = data.headline;
    this.anchor = data.anchor;
    this.previewSmall = data.previewSmall;
    this.previewLarge = data.previewLarge;

    const routesByDay: { [key: number]: number } = {};
    data.routes
      .sort((a, b) => a.day - b.day)
      .forEach((item) => {
        if (!routesByDay[item.day]) {
          routesByDay[item.day] = 0;
        }
        routesByDay[item.day]++;
      });
    for (let day in routesByDay) {
      this.routes.push({
        day: Number(day),
        routeCount: routesByDay[day],
      });
    }
  }
}
